var map = {
	"./activity/Router.js": 8377,
	"./auth/Router.js": 1148,
	"./benefit/Router.js": 389,
	"./error/Router.js": 8442,
	"./forget/Router.js": 7820,
	"./goods/Router.js": 8961,
	"./login/Router.js": 5866,
	"./my/Router.js": 4931,
	"./profile/Router.js": 2614,
	"./register/Router.js": 6112,
	"./shop/Router.js": 8472,
	"./trade/Router.js": 5271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2616;